import { FormattedMessage } from "react-intl";

import ArticleListingCard from "../../../components/articleListingCard/articleListingCard"
import { ListingHeaderWithYuzu } from "../../../components/listingHeader/listingHeader"
import SBEditable from "../../../components/sbEditable/sbEditable"

import styles from "./topStoriesPanel.module.scss"
import {useStoryblokTopStoriesPanelWidget} from "../../../hooks/useStoryblokTopStoriesPanelWidget";

function TopStoriesPanel({ blok }) {
  const [articles, isLoading] = useStoryblokTopStoriesPanelWidget()

  if (!isLoading && articles.length === 0) {
    return null;
  }

  return (
    <SBEditable blok={blok} withClass={`${styles.topStoriesPanel} ${blok.margin_top ? styles.marginTopDefault : ""} ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}>
      <ListingHeaderWithYuzu>
        <h3><FormattedMessage id="component.top_stories_panel.headline" /></h3>
      </ListingHeaderWithYuzu>
      <ul className={styles.list}>
        {isLoading ? <div className="loader centered" /> : null}
        {articles.map((a)=>(
          <li key={a._uid}>
            <ArticleListingCard
              layout="inlinetopstories"
              date_new_line={true}
              slug={a.slug}
              thumbnail={a.content.thumbnail}
              authors={a.content.authors}
              title={a.content.headline}
              date={a.content.article_date}
              article_category={a.content.category}
              article_type={a.content.article_type}
              comment_count={5}
              enable_comments={a.content.has_comments}
              enable_social_sharing={a.content.has_social_sharing}
              use_legacy_thumbnail_background={a.content.legacy_thumbnail_background}
            />
          </li>
        ))}
      </ul>
    </SBEditable>
  )
}

export default TopStoriesPanel
